import React from 'react';
interface Bonus {
  icon: string;
  title: string;
  desc: string;
  extra: string;
  value: string;
}
export function Bonuses() {
  const bonuses: Bonus[] = [{
    icon: '🎨',
    title: 'El "Slide Master" de Filosofía',
    desc: '60 presentaciones visuales (Canva/PPT) listas para proyectar. Diseñadas con estética moderna para capturar la atención visual de tus alumnos desde el primer segundo.',
    extra: '',
    value: 'USD 15'
  }, {
    icon: '🧠',
    title: 'Banco de Actividades "Anti-IA"',
    desc: 'El sistema de talleres y guías de escritura que las inteligencias artificiales no pueden resolver.',
    extra: 'Actividades basadas en la experiencia personal, el contexto propio del alumno y la reflexión crítica profunda.',
    value: 'USD 12'
  }, {
    icon: '🎬',
    title: 'El "Video-Club" Filosófico',
    desc: 'Guía cinematográfica con 30 películas y series analizadas bajo conceptos filosóficos. Fichas de trabajo para que ver una película en clase sea una experiencia académica real.',
    extra: '',
    value: 'USD 10'
  }, {
    icon: '🗣️',
    title: 'Guía de Dinámicas de Debate',
    desc: '20 técnicas de debate grupal para despertar a los grupos más silenciosos. Dinámicas para que todos participen, se escuchen y aprendan a disentir con respeto.',
    extra: '',
    value: 'USD 9'
  }];
  return <section className="py-8 md:py-12 px-4 bg-brand-cardAlt border-y border-black/5" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-brand-text" data-id="element-49">
          🎁 LOS 4 BONOS ESTRATÉGICOS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8" data-id="element-50">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded p-5 border border-black/10 flex flex-col" data-id="element-51">
              <h3 className="text-base md:text-lg font-bold text-brand-text mb-2 flex items-center gap-2" data-id="element-52">
                <span data-id="element-53">{bonus.icon}</span>
                BONO 0{i + 1} — {bonus.title}
              </h3>
              <p className="text-xs font-bold text-brand-text/60 mb-3" data-id="element-54">
                Valor real: {bonus.value} →{' '}
                <span className="text-brand-success" data-id="element-55">
                  Incluido sin costo extra
                </span>
              </p>
              <p className="text-sm text-brand-text leading-relaxed mb-2" data-id="element-56">
                {bonus.desc}
              </p>
              {bonus.extra && <p className="text-sm text-brand-text leading-relaxed mt-auto" data-id="element-57">
                  {bonus.extra}
                </p>}
            </div>)}
        </div>

        <div className="bg-brand-card rounded p-6 text-center border border-brand-gold/30 max-w-md mx-auto" data-id="element-58">
          <div className="flex justify-between items-center border-b border-black/5 pb-4 mb-4" data-id="element-59">
            <span className="text-base font-bold text-brand-text" data-id="element-60">
              Valor total de los 4 Bonos
            </span>
            <span className="text-base font-bold text-brand-text/50 line-through" data-id="element-61">
              USD 46.00
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-62">
            <span className="text-lg font-bold text-brand-text" data-id="element-63">
              Tu precio hoy
            </span>
            <span className="text-xl font-bold text-brand-gold" data-id="element-64">
              🎁 INCLUIDOS
            </span>
          </div>
          <p className="text-xs text-brand-text/60 mt-4" data-id="element-65">
            Solo en este lanzamiento. Incluidos siempre.
          </p>
        </div>
      </div>
    </section>;
}